var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHandwrittenArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 116,
  height: 73,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#25221e",
  strokeLinecap: "round",
  strokeOpacity: 0.49,
  strokeWidth: 2,
  d: "M19.579 57.884c4.223-40.441 46.154-55.72 63.595-30.434 7.113 10.33-2.567 20.258-10.163 13.1-4.761-4.536-1.897-13.148 6.76-16.752 10.882-4.532 21.237-6.214 28.706-5.415"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#25221e",
  fillOpacity: 0.49,
  d: "M25.148 58.544a.92.92 0 0 0-.714.135q-.287.216-.565.777a14.4 14.4 0 0 1-1.831 2.528 15 15 0 0 1-2.27 2.124q-.878.675-1.694 1.02a13 13 0 0 1-1.155-1.806q-.651-1.23-1.119-2.522a24 24 0 0 1-.767-2.431q-.18-.6-.373-.882a.72.72 0 0 0-.481-.312q-.45-.086-.837.136a1.08 1.08 0 0 0-.457.724 2 2 0 0 0-.033.436q.026.25.173.77.201.75.561 1.704.355.976.82 2.023.489 1.05 1.019 2.011.554.965 1.125 1.712.293.4.492.512.225.115.46.16.167.033.39.025.218.017.614-.129.83-.236 1.79-.888a14.5 14.5 0 0 0 1.96-1.52q.975-.871 1.832-1.888a15.4 15.4 0 0 0 1.458-1.984q.228-.424.315-.628.089-.205.142-.49.086-.45-.112-.832t-.743-.485"
})));
export default SvgHandwrittenArrow;